module.exports = __webpack_public_path__ + "img/cc.ffce1992.svg";